// extracted by mini-css-extract-plugin
export default {"menuButton":"_2wEfi3jC4ziP7V7cAMHZDX","arrow":"_176fUw46Or7q1cyIlBkB24","buttonIcon":"_1m6GDCjiZrU_sU6EmVqNUL","primary":"_35V50dp0gHi904EhdhlVRm","outline":"ZcG59s58U25zxxjuniLZ"};